
import {
getNewUserGoods,
newUserBindCoupon
} from "@/api/newcomersList.js";
import {
getCookie
} from "@/utils/auth.js";
import Api from '@/api.js';
import Alert from 'vux/src/components/alert/index.vue'
import LoadMore from 'vux/src/components/load-more/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Confirm from 'vux/src/components/confirm/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import Loading from 'vux/src/components/loading/index.vue'

export default {
data() {
return {
new_user_page_popup_url: "",
new_user_gift_url: "",
order_unlock_popup_url: "",
new_user_page_header_url: "",
goodList: [],
showNewUser: false,
showNewUserActivity: false,
showUserGift: false,
showOrderPopup: false
};
},

components: {

},

computed: {},

created() {

},

mounted() {
this.bindStatus = this.$route.query.bindStatus;

if (this.$route.query.new_user_page_popup_url || this.$route.query.new_user_gift_url || this.$route.query.order_unlock_popup_url ||
this.$route.query.new_user_page_header_url) {
this.new_user_page_popup_url = this.$route.query.new_user_page_popup_url;
this.new_user_gift_url = this.$route.query.new_user_gift_url;
this.order_unlock_popup_url = this.$route.query.order_unlock_popup_url;
this.new_user_page_header_url = this.$route.query.new_user_page_header_url;
}
if (this.bindStatus == "false") {
this.showNewUser = true;
this.showNewUserActivity = true; 
sa.track('notice_show', {
notice_type: "新人首单红包",
page_name: "新人专享页",
belong_page: location.href,
});
}
this.getNewUserGoodsFun(); 
},
methods: {

getNewUserGoodsFun: function() {
let _this = this;
getNewUserGoods().then(res => {
console.log("新人专享返回---------", res)
if (res.code == 1) {
_this.goodList = res.data;
}
})

},

headerFun: function() {
this.$vux.toast.text('当前页面下单，即可解锁新人券包', 'middle')
},

gotoGoodInfoFun: function(goodsCode) {
location.href = Api.goodUrl + "/detail/" + goodsCode;
},

newUserActivityFun: function() {
sa.track('notice_click', {
notice_type: "新人首单红包",
page_name: "新人专享页",
belong_page: location.href,
click_type: 1
});
let that = this;
newUserBindCoupon().then(res => {
console.log(res.data)
if (res.code == 1) {
that.showNewUserActivity = false;

if (that.order_unlock_popup_url != undefined && that.order_unlock_popup_url != null && that.order_unlock_popup_url !=
"") {
that.showOrderPopup = true;
sa.track('notice_show', {
notice_type: "新人解锁红包",
page_name: "新人专享页",
belong_page: location.href,
});
} else {
that.showNewUser = false;
}

} else {
that.showNewUser = false;
that.showNewUserActivity = false;
this.$vux.toast.text(res.desc, 'middle')
}
})
},

orderPopupFun: function() {
sa.track('notice_click', {
notice_type: "新人解锁红包",
page_name: "新人专享页",
belong_page: location.href,
click_type: 1
});

if (this.new_user_gift_url != undefined && this.new_user_gift_url != null && this.new_user_gift_url != "") {

this.showOrderPopup = false;
this.showUserGift = true;
sa.track('notice_show', {
notice_type: "新人礼包",
page_name: "新人专享页",
belong_page: location.href,
});
} else {
this.showNewUser = true;
}

},

newUserGiftFun: function() {
sa.track('notice_click', {
notice_type: "新人礼包",
page_name: "新人专享页",
belong_page: location.href,
click_type: 1
});
this.showNewUser = false;
this.showOrderPopup = false;
},
},
};



// WEBPACK FOOTER //
// ./src/view/newcomer/newcomersList.vue